const connectRoutes = ['/connect/login', '/connect/signup', '/connect/forgot-password', '/connect/confirm-account', '/connect/signin-with-token', '/connect/', '/connect/reset-password'];

export default connectRoutes;
